module.exports = __webpack_public_path__ + "static/media/deliveree-page-not-found.74528c99.png";